import * as Reflect from "../reflect-metadata";

(<any>global).Reflect = Reflect;

export * from "../reflect-metadata";



/** WEBPACK FOOTER **
 ** ./src/global/node.ts
 **/